import { InitFeatureParams } from '@/features/types'
import { getRoutes } from './routes'

export const initQuizTask = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
